import { IPractitioner } from '../modules/unsw-fhir/Practitioner';

export const getGender = (patient: IPractitioner | undefined): string => {
  if (!patient) return 'Unknown';
  return patient.gender || 'unknown';
};

export const isActive = (patient: IPractitioner | undefined): boolean => {
  if (!patient) return false;
  return !!patient.active;
};

export const getFirstName = (
  practitioner: IPractitioner | undefined,
): string => {
  if (!practitioner || !practitioner.name || practitioner.name.length <= 0)
    return 'Unknown';
  const name =
    practitioner.name.find(p => p.use === 'official') || practitioner.name[0];
  return name.given && name.given[0] ? name.given[0] : 'Unknown';
};

export const getEmail = (
  practitioner: IPractitioner | undefined,
): string | undefined => {
  if (
    !practitioner ||
    !practitioner.telecom ||
    practitioner.telecom.length <= 0
  )
    return undefined;
  const email = practitioner.telecom.find(
    p => p.use === 'work' && p.system === 'email',
  );
  return email && email.value;
};

export const getLastName = (
  practitioner: IPractitioner | undefined,
): string => {
  if (!practitioner || !practitioner.name || practitioner.name.length <= 0)
    return 'Unknown';
  const name =
    practitioner.name.find(p => p.use === 'official') || practitioner.name[0];
  return name.family || 'Unknown';
};

export const getDisplayName = (
  practitioner: IPractitioner | undefined,
): string => {
  if (!practitioner || !practitioner.name || practitioner.name.length <= 0)
    return 'Unknown';
  const name =
    practitioner.name.find(p => p.use === 'official') || practitioner.name[0];
  return (
    name.text || `${getFirstName(practitioner)} ${getLastName(practitioner)}`
  );
};
